import React from "react";

// ProductDetail_SellerLeft_Tailwind_v8.jsx
// Gọn margin/padding để mobile đọc hết mà không cần cuộn nhiều.

export default function ProductDetailSellerLeft() {
    return (
        <div className="min-h-screen p-2 sm:p-6">
            <div className="max-w-6xl mx-auto bg-gradient-to-tr from-sky-50 to-white rounded-2xl shadow-md overflow-hidden border border-dashed border-gray-300">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 sm:gap-5 p-2 sm:p-5">

                    {/* RIGHT: Product details */}
                    <section className="col-span-2 order-1 lg:order-none">
                        <div className="px-2 sm:px-6 lg:px-8">
                            <h1 className="text-base sm:text-2xl font-extrabold text-gray-800">
                                ACC HUST MEDIA - 1M coins (Bảo hành 1 tháng). Định dạng:TK|MK|SỐ COINS
                            </h1>

                            <div className="mt-1 sm:mt-2 flex flex-wrap gap-2">
                                <span className="px-2 py-1 rounded-md bg-purple-400 text-white text-xs sm:text-sm font-semibold">
                                    Kho hàng: 44
                                </span>
                                <span className="px-2 py-1 rounded-md bg-teal-400 text-white text-xs sm:text-sm font-semibold">
                                    Đã bán: 2.278
                                </span>
                            </div>

                            <div className="mt-2 sm:mt-3 flex items-center justify-between flex-wrap gap-3 sm:gap-4">
                                <div>
                                    <div className="text-lg sm:text-2xl font-extrabold text-teal-700">
                                        14.000 coins
                                    </div>
                                    <p className="mt-1 sm:mt-2 text-gray-600 max-w-2xl text-xs sm:text-sm">
                                        Tài khoản định dạng: TK|MK|SỐ COINS. Acc Hust Media kiểm tra kỹ
                                        trước khi đưa lên hệ thống. Sau khi mua, vui lòng đổi mật khẩu để an toàn.
                                    </p>
                                </div>

                                <div className="flex items-center gap-2 w-full sm:w-auto">
                                    <button className="flex-1 sm:flex-none px-3 py-2 sm:px-5 sm:py-3 rounded-lg bg-gradient-to-r from-cyan-600 to-sky-700 text-white font-bold shadow-md text-sm sm:text-base">
                                        🛒 MUA NGAY
                                    </button>
                                    <button
                                        onClick={() => window.history.back()}
                                        className="flex-1 sm:flex-none px-3 py-2 sm:px-5 sm:py-3 rounded-lg border border-gray-200 text-gray-700 font-medium text-sm sm:text-base"
                                    >
                                        ↩️ QUAY LẠI
                                    </button>
                                </div>
                            </div>

                            <div className="mt-3 sm:mt-4 border-t pt-2 sm:pt-3">
                                <div className="mt-2 sm:mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">

                                    <div className="bg-sky-50 rounded-xl p-3 sm:p-5 border shadow-sm">
                                        <h4 className="font-semibold text-gray-800 text-sm sm:text-base">
                                            Mô tả chi tiết
                                        </h4>
                                        <p className="mt-1 sm:mt-2 text-gray-600 text-xs sm:text-sm">
                                            Chỉ bảo hành khi mua qua App. Nếu có giới thiệu mua nơi khác sẽ không được bảo hành.
                                        </p>
                                    </div>

                                    <div className="bg-indigo-50 rounded-xl p-3 sm:p-5 border shadow-sm">
                                        <h4 className="font-semibold text-gray-800 text-sm sm:text-base">
                                            Thông tin shop
                                        </h4>
                                        <ul className="mt-1 sm:mt-2 space-y-1 sm:space-y-2 text-gray-600 text-xs sm:text-sm">
                                            <li>📍 Việt Nam</li>
                                            <li>⏱️ 24h</li>
                                            <li>🔒 Giao dịch tự động</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* LEFT: Seller panel */}
                    <aside className="col-span-1 flex flex-col items-center order-2 lg:order-none">
                        <div className="w-full bg-purple-50 rounded-2xl border shadow-sm p-3 sm:p-4 flex flex-col items-center text-center">
                            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-gradient-to-tr from-indigo-500 to-sky-400 flex items-center justify-center text-white text-lg sm:text-xl font-extrabold">
                                HM
                            </div>

                            <h3 className="mt-2 sm:mt-3 text-sm sm:text-base font-semibold text-gray-800">
                                Acc Hust Media
                            </h3>
                            <p className="text-xs sm:text-sm text-gray-500">Shop uy tín</p>

                            <div className="mt-1 sm:mt-2 flex items-center gap-1 sm:gap-2">
                                <span className="px-2 py-1 rounded-full bg-emerald-500 text-white text-xs font-semibold">
                                    ⭐ 4.9
                                </span>
                                <span className="px-2 py-1 rounded-full bg-rose-500 text-white text-xs font-semibold">
                                    Đã bán: 2.2k
                                </span>
                            </div>

                            <div className="mt-2 sm:mt-3 w-full flex flex-col gap-2 sm:gap-3">
                                <button className="px-3 py-2 rounded-lg bg-gradient-to-r from-emerald-500 to-green-500 text-white font-semibold shadow-md text-sm sm:text-base">
                                    📩 Chat
                                </button>
                            </div>
                        </div>
                    </aside>

                </div>
            </div>
        </div>
    );
}
